export const checkMinLength = async (value: string, minLength: number): Promise<string> => {
  return value.length && value.length < minLength ? `Enter at least ${minLength} symbols` : ''
}
